import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import configurationAPI from '../../apis/configuration/configurationAPI';

function AddAuditAreaModal({ onHide, show, clientId, locationId, setSuccess, fetchNewAuditAreas }) {
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        name: '',
    });

    const onSubmit = async (data) => {
        try {
            const response = await configurationAPI.addAuditArea({ data, clientId, locationId });
            if (response?.success) {
                window.toastr.success(response?.message);
                onHide();
                setSuccess(true);
                fetchNewAuditAreas();
            }
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <Modal onHide={onHide} centered show={show}>
            <Modal.Header>
                <Modal.Title>
                    Add Audit Area
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="form mx-5 mx-xl-7 my-7"

                >
                    <div className="row justify-content-center">
                        <div className="fv-row mb-7 col-lg-7">
                            <label className="fs-6 fw-semibold mb-2 required">
                                <span>Name</span>
                            </label>
                            <input
                                {...register('name', { required: true })}
                                className="form-control"
                            />
                            {errors.name && (
                                <p className="text-danger">
                                    Required
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="d-flex pt-3 flex-left justify-content-center gap-3">
                        <button type="button" className="btn btn-light-primary" onClick={onHide}>Cancel</button>
                        <button
                            className="btn btn-primary"

                        >Save
                        </button>
                    </div>
                </form>
            </Modal.Body>

        </Modal>
    )
}

export default AddAuditAreaModal